// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subtext[data-v-eedfb77e]{margin-bottom:10px;font-style:italic}.admin[data-v-eedfb77e]{display:flex;justify-content:center;margin:30px 0 10px;font-weight:700}", ""]);
// Exports
module.exports = exports;
